<template>
  <div class="container">
    <v-row no-gutters justify="center" align="center" class="h-100">
      <v-col class="text-center">
        <!-- <v-icon class="status-icon-container" color="#fff" size="80">{{
          allStatus[1].icon
        }}</v-icon> -->

        <div class="mb-8">
          <h1>Xift is {{ allStatus[0].description }}</h1>
          <div class="mt-4">
            <p class="processed-mail">
              Last Processed Email:
              <span class="f-bold" v-if="processedMailDuration">{{
                getFormatedDateAsPerTimeAndDate(processedMailDuration)
              }}</span>
            </p>
          </div>
          <h6 class="secondary-text">
            Having trouble? Email us at
            <a href="mailto:info@xift.com">info@xift.com</a>
          </h6>
        </div>
        <!-- <v-row no-gutters class="status-container px-2 py-2 mx-4">
          <v-col v-for="status in Object.values(allStatus)" :key="status.color">
            <v-row no-gutters justify="center" align="center">
              <v-icon :color="status.color" size="20">{{ status.icon }}</v-icon>
              <p class="statusTag ml-2">{{ status.label }}</p>
            </v-row>
          </v-col>
        </v-row> -->
      </v-col>
    </v-row>
  </div>
</template>
<script>
import serviceStatus from '@/services/PublicAPIService';
export default {
  data() {
    return {
      flag: 1,
      processedMailDuration: '',
      allStatus: {
        0: {
          icon: 'mdi-check',
          label: 'No Issues',
          type: 'working',
          color: '#2bac76',
          description: 'up and running'
        },
        1: {
          icon: 'mdi-tools',
          label: 'Maintenance',
          type: 'maintenance',
          color: '#19174a',
          description: 'under maintenance'
        },
        2: {
          icon: 'mdi-minus',
          label: 'Outage',
          color: '#e53636',
          type: 'outage',
          description: 'in outage'
        }
      }
    };
  },
  mounted() {
    this.serviceStatus();
  },
  methods: {
    async serviceStatus() {
      const data = await serviceStatus.getServiceStatus();
      const parsedData = this.parseResponse(data);
      this.processedMailDuration = parsedData[0].lastProcessed;
      this.processedMailDuration = this.getFormatedDateAsPerTimeZone(
        this.processedMailDuration
      );
    }
  }
};
</script>
<style lang="scss" scoped>
// font-size: 80px;
// width: 150px;
// height: 150px;
// color: #fff;
// caret-color: rgb(43, 172, 118);
// border: 2px solid rgb(57 175 125);
// border-radius: 80px;
// box-shadow: 1px 1px 8px 2px rgb(57 175 125);
// background: rgb(43, 172, 118);
.status-icon-container {
  width: 150px;
  height: 150px;
  border-radius: 80px;
}
.status-icon-ma .container {
  display: flex;
  justify-content: center;
  align-items: center;
}
.heading {
  color: #19174a;
  margin-top: 32px;
  margin-bottom: 16px;
}
.status {
  margin-top: 4px;
  margin-bottom: 16px;
}
.processed-mail {
  color: #595d5d;
  font-size: 12px;
  margin-bottom: 4px;
}
.status-container {
  background-color: #fafafa;
  border-radius: 4px;
}
.statusTag {
  margin: 0px;
  font-size: 12px;
}
</style>
